import { ParamComponent } from './room-param.component';

export const Param = ParamComponent;
